import React, { useEffect, useRef, useState } from 'react'
import { FaUpload } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { setError } from '../../store/common/generalSlice';

let imageTypes = ['image/png', 'image/jpg', 'image/jpeg']

const DisputeFormEvidencePicker = ({ onChange }) => {

    const fileRef = useRef(null);
    const dispatch = useDispatch()

    const [imageState, setImageState] = useState({
        previewImage: '',
        imageObject: null
    })

    const fileUploadHandler = () => {
        fileRef.current.click()
    }

    const fileHandler = (e) => {
        if (e.target.files[0]) {
            let imageType = e.target.files[0]?.type;
            if (!imageTypes.find((type) => type == imageType)) {
                dispatch(setError('Image Format is invalid'))
            }
            else {
                const Url = URL.createObjectURL(e.target.files[0])
                setImageState({
                    previewImage: Url,
                    imageObject: e.target.files[0]
                })
                onChange(e.target.files[0])
            }
        }
    }

    // Cleanup function for the URL object
    useEffect(() => {
        return () => {
            if (imageState.previewImage) {
                URL.revokeObjectURL(imageState.previewImage);
            }
        };
    }, [imageState.previewImage]);



    return (
        <div className='w-full border border-dashed border-[#B1BBC9] cursor-pointer rounded-md flex flex-col items-center justify-center py-4 gap-2 bg-[#F3F6F8] relative' onClick={fileUploadHandler}>
            <FaUpload />
            <span>Browse File</span>
            <input type='file' hidden ref={fileRef} onChange={fileHandler} />
            {imageState.previewImage && (
                <div className="absolute top-0 bottom-0">
                    <img src={imageState.previewImage} alt="Preview" className="w-full h-full object-contain object-center" />
                </div>
            )}
        </div>
    )
}

export default DisputeFormEvidencePicker